import * as React from 'react';
import { Header1, Header2, useDeviceType } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';

import { Wrapper } from '../Wrapper';
import { ReportExampleBlock, IReportExampleBlockProps } from './components/ReportExampleBlock';
import { StepCards } from './components/StepCards';
import { NBSP } from '../../constants/symbols';

import * as styles from './styles.css';

type IReportExampleProps = IReportExampleBlockProps;

export const ReportExample: React.FC<IReportExampleProps> = props => {
  const isDesktop = useDeviceType() === 'desktop';

  return (
    <div className={styles['container']}>
      <Wrapper>
        <div className={styles['title']}>
          <ConditionalWrapper if={isDesktop} ThenComponent={Header1} ElseComponent={Header2}>
            <>
              В течение 3-х рабочих дней проверим недвижимость и{NBSP}подготовим{NBSP}отчёт с возможными рисками
            </>
          </ConditionalWrapper>
        </div>
        <div className={styles['step_cards']}>
          <StepCards />
        </div>
      </Wrapper>
      <ConditionalWrapper if={isDesktop} ThenComponent={Wrapper as React.FC}>
        <div className={styles['report_card']}>
          <ReportExampleBlock {...props} />
        </div>
      </ConditionalWrapper>
    </div>
  );
};

ReportExample.displayName = 'ReportExample';
